import { WEEK } from '../../../../constants';

export const DAY_OPTIONS = Array.from({ length: 31 }, (_, index) => ({
  label: `${index + 1}日`,
  value: index + 1,
}));

export const WEEK_DAY_OPTIONS = Array.from({ length: 7 }, (_, index) => ({
  label: `星期${WEEK[index]}`,
  value: index,
}));
